import React from 'react';
import { SvgIcon } from '@mui/material';

const Microphone = ({ ...props }) => (
    <SvgIcon {...props} width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <g id="Style-Guide" stroke="none" strokeWidth="1" fill="inherit" fillRule="evenodd">
            <g transform="translate(-672.000000, -2276.000000)" id="Icons">
                <g transform="translate(48.000000, 2212.000000)">
                    <g id="Microphone-Enabled-Icon" transform="translate(624.000000, 64.000000)">
                        <g id="1.-Icon/Voice/On">
                            <path
                                d="M22.5908,12.6893 C23.4178,12.6893 24.0888,13.3593 24.0888,14.1863 C24.0888,18.3843 21.0408,21.8773 17.0438,22.5893 L17.0438,22.5893 L17.0438,26.4933 C17.0438,27.3203 16.3728,27.9913 15.5468,27.9913 C14.7198,27.9913 14.0498,27.3203 14.0498,26.4933 L14.0498,26.4933 L14.0498,22.5903 C10.0498,21.8803 6.9998,18.3863 6.9998,14.1863 C6.9998,13.3593 7.6708,12.6893 8.4968,12.6893 C9.3238,12.6893 9.9948,13.3593 9.9948,14.1863 C9.9948,17.2473 12.4848,19.7353 15.5448,19.7353 C18.6058,19.7353 21.0938,17.2473 21.0938,14.1863 C21.0938,13.3593 21.7648,12.6893 22.5908,12.6893 Z M15.5449,4 C18.0349,4 20.0549,6.019 20.0549,8.51 L20.0549,8.51 L20.0549,14.147 C20.0549,16.638 18.0349,18.658 15.5449,18.658 C13.0539,18.658 11.0339,16.638 11.0339,14.147 L11.0339,14.147 L11.0339,8.51 C11.0339,6.019 13.0539,4 15.5449,4 Z"
                                id="Combined-Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
export default Microphone;
